import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InvestingEntityWithRelatedInvestmentsHolding, InvestmentsRelatedDetails } from '../../models/investingEntityWithRelatedInvestmentsHolding.model';
import { TerraUtils } from 'src/app/shared/TerraUtils';
import { AppSettingsService } from 'src/app/services/app-settings.service';

@Component({
  selector: 'terra-investing-entity-with-related-investments-holding-warning-dialog',
  templateUrl: './investing-entity-with-related-investments-holding-warning-dialog.component.html',
  styleUrl: './investing-entity-with-related-investments-holding-warning-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestingEntityWithRelatedInvestmentsHoldingWarningDialogComponent {
  public readonly INVESTMENT_TYPE_ORDER = ['Distributions', 'Commitments', 'Contributions']
  constructor(
    public dialogRef: MatDialogRef<InvestingEntityWithRelatedInvestmentsHoldingWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvestingEntityWithRelatedInvestmentsHolding[],
    private appSettingService: AppSettingsService
  ) {
    this.dialogRef.updateSize('700px')
  }

  getRelevantInvestmentType(investmentsDetails: InvestmentsRelatedDetails[], investmentType: string): InvestmentsRelatedDetails[] {
    return investmentsDetails.filter(investment => investment.relatedType === investmentType);
  }

  getHoldinRoute(id:number, holdingDiscriminator:string){
    const holdingPath = holdingDiscriminator === 'Fund' ? TerraUtils.consts.paths.FUNDS : TerraUtils.consts.paths.ASSETS;
    return `${this.appSettingService.gpFrontEnvironmentAppBaseUrl}${holdingPath}/${id}`;
  }
}
